module.exports = __webpack_public_path__ + "img/racecourse-turffontein-turf-inner.270c6bc9.svg";